import { render, staticRenderFns } from "./AutoAssignTieBreaking.vue?vue&type=template&id=2994c2d0&"
import script from "./AutoAssignTieBreaking.vue?vue&type=script&lang=js&"
export * from "./AutoAssignTieBreaking.vue?vue&type=script&lang=js&"
import style0 from "./AutoAssignTieBreaking.vue?vue&type=style&index=0&id=2994c2d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports